module.exports = __webpack_public_path__ + "static/media/search-lends.8eaded2e.svg";